<template>
	<div class="backgroundImage">
		<h5>Background Image</h5>

		<div>
			<b-tabs content-class="mt-3" fill>
				<b-tab v-for="(property, size) in backgroundImage" :key="size">
					<template slot="title">
						<label>{{ size }}</label>
					</template>
					<ImageUploader :imageFieldKey="size" :imageFieldObject="backgroundImage" :forTemplate="forTemplate" :size="size"></ImageUploader>
				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>

<script>

	import 'vue2-dropzone/dist/vue2Dropzone.min.css'
	import ImageUploader from './ImageUploader.vue'

	export default {

		components: {
			ImageUploader
		},

		name: 'BackgroundImage',
		
		props: ['backgroundImage', 'forTemplate'],

		data: function () {
			return {
				dropzoneOptions: {
					url: "https://fqwrgdp5j1.execute-api.eu-west-2.amazonaws.com/prod/upload-image",
					thumbnailWidth: 150,
					maxFilesize: 2,
					maxFiles:1,
					headers:{
						Authorization:this.$store.getters['authToken']
					}
				}
			}
		},
		methods:{
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';
	
	.backgroundImage{
		padding: 20px 0;
	}
	h5{
		padding-bottom: 10px;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>